import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import LinkedInSidebar from '../LinkedInSidebar';
import axios from "axios";
import Cookies from "js-cookie";
import { Bell, Settings } from "lucide-react";
import Modal from '../Elements/Modal';
import TableFromJson from '../Elements/TableFromJson';
import ReactMarkdown from 'react-markdown';

const Notification = ({ name, settings, mainKey, changeNotificationSettings }) => {
  
  const handleToggle = () => {
    const block = settings[mainKey];

    // Проверка: объект ли это и содержит ли "enabled"
    if (typeof block === "object" && block !== null && "enabled" in block) {
      changeNotificationSettings(!block.enabled, mainKey, "enabled");
    }
  };

  return (
    <>
    <div className="mt-4 flex items-center">
      <button
        onClick={handleToggle}
        className={`relative inline-flex items-center h-4 w-7 rounded-full transition-colors duration-300 ${
          typeof settings[mainKey] === "object" && settings[mainKey] !== null && "enabled" in settings[mainKey] && settings[mainKey].enabled ? 'bg-gray-400' : 'bg-gray-300'
        }`}
      >
        <span
          className={`inline-block w-3 h-3 transform bg-white rounded-full transition-transform duration-300 ${
            typeof settings[mainKey] === "object" && settings[mainKey] !== null && "enabled" in settings[mainKey] && settings[mainKey].enabled ? 'translate-x-3.5' : 'translate-x-0.5'
          }`}
        />
      </button>

      <span className="ml-3 text-sm text-gray-600 font-main-medium">
        {typeof settings[mainKey] === "object" && settings[mainKey] !== null && "enabled" in settings[mainKey] && settings[mainKey].enabled === true && (
          <span>{name} ({settings[mainKey].from}-{settings[mainKey].to})</span>
        )}
        {typeof settings[mainKey] === "object" && settings[mainKey] !== null && "enabled" in settings[mainKey] && settings[mainKey].enabled === false && (
          <span>{name} (Disabled)</span>
        )}
      </span>
    </div>
    {typeof settings[mainKey] === "object" && settings[mainKey] !== null && "enabled" in settings[mainKey] && settings[mainKey].enabled === true && (
      <div className="flex justify-between gap-2 w-full">
        <input
          type="text"
          value={settings[mainKey].from}
          onChange={(e) => changeNotificationSettings(e.target.value, mainKey, "from")}
          placeholder="From"
          className="bg-transparent text-sm text-center font-main-medium placeholder:text-sm placeholder:font-main-light border rounded-md w-full max-w-[150px] px-2 py-2"
        />

        <input
          type="text"
          value={settings[mainKey].to}
          onChange={(e) => changeNotificationSettings(e.target.value, mainKey, "to")}
          placeholder="To"
          className="bg-transparent text-sm text-center font-main-medium placeholder:text-sm placeholder:font-main-light border rounded-md w-full max-w-[150px] px-2 py-2"
        />
      </div>
    )}
  </>
  );
};

export default Notification;
